import Heatstroke from "../../../front/components/Heatstroke";

// スライドページ
const vm = new Vue({
    el: '#heatstroke-slide-app',
    components: {
        Heatstroke
    },
    template: '<Heatstroke />',
})

// トップページ
const vm2 = new Vue({
    el: '#heatstroke-top-app',
    components: {
        Heatstroke
    },
    template: '<Heatstroke />',
})
